import { createQueryKeys } from '@lukemorales/query-key-factory';

import type { FetchMetricsArgs } from '../api/types/stats.types';

import { fetchMetricDefinitions } from '../api/statsRegistry.api';

export const statsRegistryQueryKeys = createQueryKeys('statsRegistry', {
  fetchMetrics: (args: FetchMetricsArgs = {}) => ({
    queryFn: () => fetchMetricDefinitions(args),
    queryKey: [args],
  }),
});
